import MuiAlert from "@mui/material/Alert";
const Alert = MuiAlert;
export default Alert;
